export function createAnalyticsCategories(categories: string[]): Record<string, string> {
  return categories.reduce(
    (acc, category, index) => {
      const key = index === 0 ? 'item_category' : `item_category${index + 1}`;
      (acc as any)[key] = category;

      return acc;
    },
    {} as Record<string, string>,
  );
}
